<template>
  <el-drawer
    ref="interCityInfo"
    :visible.sync="visible"
    :direction="direction"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="70%"
    withHeader="false"
    v-loading="loading"
    element-loading-text="正在加载中～"
    append-to-body
  >
    <template #title>
      <div style="display: flex; align-items: center">
        <span>{{ title }}</span>
        <img
          v-if="info && info.buyChannel === 7"
          src="@/static/tc.png"
          style="width: 25px; height: 25px; margin-right: 10px"
        />
      </div>
    </template>
    <el-row :gutter="20">
      <el-col :span="24">
        <div>
          <div class="topBox">
            <el-steps align-center process-status="finish" finish-status="success" space="700px">
              <el-step
                v-for="(item, index) of info.timePoints"
                :key="index"
                :title="item.operate"
                :description="item.timePoint"
              />
            </el-steps>
            <div class="tipsBtn">
              <div style="display: flex; justify-content: flex-end">
                <template v-if="isCancelShow">
                  <el-button
                    v-has-permi="['order_intercity_tc']"
                    type="primary"
                    size="mini"
                    :loading="tcLoading"
                    @click="handleCancelOrder"
                  >
                    取消订单
                  </el-button>
                </template>
                <el-button
                  v-if="info.state === 8 || info.state === 0"
                  type="danger"
                  size="mini"
                  @click="handleEndTrip"
                  v-has-permi="['custom_end_trip']"
                >
                  结束行程
                </el-button>
                <div
                  v-if="
                    info.state === 0 ||
                    info.state === 7 ||
                    info.state === 9 ||
                    info.state === 6 ||
                    info.state === 8
                  "
                  style="margin-left: 10px"
                >
                  <!--未支付隐藏退款按钮-->
                  <!-- <template v-if="info.payStatus === 2 && !editdata.tc"> -->
                  <template v-if="info.payStatus === 2 && info.buyChannel !== 7">
                    <el-button
                      type="danger"
                      size="mini"
                      @click="handleRefund"
                      v-has-permi="['order_intercity_refund']"
                    >
                      退款
                    </el-button>
                  </template>
                  <refund-ticket ref="refundTicket" v-if="refundShowDialog" />
                </div>
                <div style="padding-left: 10px">
                  <span v-if="changeShow">
                    <el-button
                      type="danger"
                      size="mini"
                      v-has-permi="['order_intercity_change']"
                      @click="handleChangeTicket"
                    >
                      改签
                    </el-button>
                  </span>
                  <!-- <span v-if="info.buyChannel === 2 && info.buyChannel !== 7">
                    <el-button
                      type="danger"
                      size="mini"
                      v-has-permi="['order_intercity_change']"
                      @click="handleChangeTicket"
                    >
                      改签</el-button
                    >
                  </span>
                  <span v-else-if="info.state === 0 && info.buyChannel !== 7">
                    <el-button
                      type="danger"
                      size="mini"
                      v-has-permi="['order_intercity_change']"
                      @click="handleChangeTicket"
                    >
                      改签</el-button
                    >
                  </span>
                  <span v-else-if="info.state === 7 && info.buyChannel !== 7">
                    <el-button
                      type="danger"
                      size="mini"
                      v-has-permi="['order_intercity_change']"
                      @click="handleChangeTicket"
                    >
                      改签</el-button
                    >
                  </span>
                  <span v-else-if="info.state === 8 && info.buyChannel !== 7">
                    <el-button
                      type="danger"
                      size="mini"
                      v-has-permi="['order_intercity_change']"
                      @click="handleChangeTicket"
                    >
                      改签</el-button
                    >
                  </span> -->
                  <change-ticket
                    ref="changeTicket"
                    v-if="changeTicketVisible"
                    :insureDateList="insureForChange"
                    :changeEndTime="changeEndTime"
                    @changeSuccess="refreshData"
                  />
                </div>
              </div>
              <!-- <div class="tipsBox">
                <img style="vertical-align: middle;width: 20px; height: 20px" src="./static/tips.png">
                <span>并班、改签可点击上方异常改签按钮！</span>
              </div> -->
            </div>
          </div>
          <el-menu
            class="jumpMenu"
            :default-active="activeStep"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item v-for="(item, index) in tabMapOptions" :key="index" :index="item.key">
              {{ item.label }}
            </el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="24" class="scroll_cls" @scroll="onScroll">
        <div style="padding: 0 10px">
          <div class="titleBox scroll-item">
            <span class="title">基础信息</span>
          </div>
          <base-info :info="info" @refreshData="refreshData" @close="handleClose" />
          <div class="flex flex-align-end" style="width: 100%; justify-content: space-between">
            <div class="titleBox scroll-item">
              <span class="title">乘客信息</span>
              <div class="tipsBoxs">
                <img style="width: 20px; height: 20px" src="./static/tips.png" />
                <span>开票重置：将乘客【未开票】状态修改为【已开票】！</span>
              </div>
            </div>
            <el-button
              v-if="info.payStatus === 2 && info.state === 7"
              size="mini"
              type="primary"
              @click="handleItinerary"
              v-has-permi="['send_itinerary']"
            >
              行程单
            </el-button>
          </div>

          <passenger-info
            :info="info"
            @refreshData="refreshData"
            @close="handleClose"
            :orderId="orderId"
          />
          <div>
            <div class="titleBox">
              <span class="title scroll-item">接送信息</span>
              <div class="tipsBox" style="justify-content: flex-start; margin: 0 0 5px 10px">
                <img style="width: 20px; height: 20px" src="./static/tips.png" />
                <span>点击订单编号可查看接送订单详情！</span>
              </div>
            </div>
            <ferryOrder-info
              :info="info"
              @ferryOrderDetails="ferryOrderDetails"
              @close="handleClose"
            />
          </div>
          <div class="titleBox">
            <span class="title scroll-item">行程信息</span>
            <div class="tipsBox" style="justify-content: flex-start; margin: 0 0 5px 10px">
              <img style="width: 20px; height: 20px" src="./static/tips.png" />
              <span>出发时间：乘客所选上车站点出发的时间</span>
            </div>
          </div>
          <trip-info :info="info" />
          <div class="titleBox">
            <span class="title scroll-item">车次信息</span>
            <div class="tipsBox" style="justify-content: flex-start; margin: 0 0 5px 10px">
              <img style="width: 20px; height: 20px" src="./static/tips.png" />
              <span>班次时间：该班次始发地的发车时间</span>
            </div>
          </div>
          <div class="carInfo" v-if="info.trainsInfo">
            <el-form :inline="false" size="small" label-width="88">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="供应商：">{{ info.trainsInfo.merchantName }}</el-form-item>
                  <el-form-item label="班次时间：">
                    <div v-if="info.trainsInfo.adjustTime < 0">
                      {{ info.trainsInfo.otherDate }} {{ info.trainsInfo.otherTime }} -
                      <span v-if="info.trainsInfo.spanDay === 0">
                        {{ info.trainsInfo.flightPlanTime.split(' ')[1] }}
                      </span>
                    </div>
                    <div v-if="info.trainsInfo.adjustTime === 0 || info.trainsInfo.spanDay !== 0">
                      {{ info.trainsInfo.flightPlanTime }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="供应商电话：">
                    {{ info.trainsInfo.merchantPhoneNumber }}
                  </el-form-item>
                  <el-form-item label="司机信息：">{{ info.trainsInfo.driverMsg }}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="车型：">{{ info.trainsInfo.carType }}</el-form-item>
                  <el-form-item label="车辆信息：">{{ info.trainsInfo.carMsg }}</el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="titleBox scroll-item">
            <span class="title">开票信息</span>
            <div class="tipsBox" style="justify-content: flex-start; margin: 0 0 5px 10px">
              <img style="width: 20px; height: 20px" src="./static/tips.png" />
              <span>展示乘客端开票记录，红冲后乘客可重新开票！</span>
            </div>
          </div>
          <invoiceDetail-info
            :info="info"
            @handleResetRed="handleResetRed"
            :isRedHandle="isRedHandle"
            :currentSerialNo="currentSerialNo"
            @refresh="refreshData"
          />
          <div class="titleBox">
            <span class="title scroll-item">交易信息</span>
          </div>
          <div class="transactionInfo">
            <span>已付金额：{{ info.paidAmount }}</span>
            <span>已退金额：{{ info.refundAmount }}</span>
            <span>订单剩余金额：{{ info.surplusAmount }}</span>
          </div>
          <transaction-info :info="info" />
          <div class="titleBox">
            <span class="title scroll-item">优惠券套餐</span>
          </div>
          <div class="transactionInfo margin-bottom-10">
            <span>套餐名称：{{ info.couponBagName || '--' }}</span>
            <span class="margin-left-30">售价：{{ info.couponBagMoney || 0 }}元</span>
          </div>
          <el-table :data="info.couponInfo" border size="mini" max-height="400px">
            <el-table-column prop="name" label="优惠券名称" align="center" />
            <el-table-column prop="discountsMoney" label="优惠金额" align="center" />
            <el-table-column prop="num" label="数量" align="center" width="80" />
            <el-table-column prop="indate" label="有效期" align="center">
              <template slot-scope="scope">
                {{ scope.row.startIndate }} - {{ scope.row.endIndate }}
              </template>
            </el-table-column>
          </el-table>
          <!--          保单状态，0,创建；1，待投保；2，投保成功；3，退保成功；4，投保失败;5，已取消；6，投保成功后退票;7,未投保；8，退保失败；9，未投保退票-->
          <div class="titleBox">
            <span class="title scroll-item">保险信息</span>
          </div>
          <insuranceOrder-info :info="info" />
        </div>
        <ferry-order v-if="isFerryOrder" ref="orderInfo" />
        <div class="scroll-item">
          <el-button
            style="margin: 20px 0 12px 12px"
            @click="showLogData"
            :loading="logLoading"
            size="small"
            type="primary"
          >
            操作日志
            <i class="el-icon-arrow-right" v-if="!showLog"></i>
            <i class="el-icon-arrow-down" v-else></i>
          </el-button>
          <div class="log-table">
            <transition name="el-fade-in-linear">
              <operation-log
                v-show="showLog"
                :visible="showLog"
                :type="2"
                :flightPlanId="flightPlanId"
                :status="status"
              />
            </transition>
          </div>
        </div>
      </el-col>
    </el-row>
    <send-itinerary
      ref="sendItinerary"
      :showItinerary="showItinerary"
      :orderNo="orderId"
      @colseItinerary="colseItinerary"
    />
  </el-drawer>
</template>

<script>
  import ChangeTicket from './change-ticket'
  import ferryOrder from '../ferry/order-info'
  import baseInfo from './base-info'
  import passengerInfo from './components/passenger-info'
  import ferryOrderInfo from './components/ferryOrder-info'
  import tripInfo from './components/trip-info'
  import invoiceDetailInfo from './components/invoiceDetail-info'
  import insuranceOrderInfo from './components/insuranceOrder-info'
  import transactionInfo from './components/transaction-info'
  import RefundTicket from './refund-ticket'
  import {
    newDetails,
    setMbOrMk,
    cancelOrder,
    orderMaxTime,
    checkRebook
  } from '@/api/intercityorder'
  import { refundDetails } from '@/api/order'
  import { resetRed, resetEndOfTrip } from '@/api/invoice'
  import OperationLog from '@/components/logInfo/list'
  import sendItinerary from './components/send-itinerary.vue'
  import dayjs from 'dayjs'

  export default {
    name: 'intercityInfo',
    filters: {
      invoStatusFilter(t) {
        if (t === 0) return '待开票'
        if (t === 1) return '已开票'
        if (t === 2) return '已作废'
        if (t === 3) return '红冲'
      }
    },
    components: {
      baseInfo,
      RefundTicket,
      ChangeTicket,
      ferryOrder,
      passengerInfo,
      ferryOrderInfo,
      tripInfo,
      invoiceDetailInfo,
      insuranceOrderInfo,
      transactionInfo,
      OperationLog,
      sendItinerary
    },
    data() {
      return {
        getUserInfo: {},
        activeStep: '0',
        isFerryOrder: false,
        title: '订单详情',
        visible: false,
        changeTicketVisible: false,
        refundShowDialog: false,
        direction: 'rtl',
        tabMapOptions: [
          { label: '基础信息', key: '0' },
          { label: '乘客信息', key: '1' },
          { label: '接送信息', key: '2' },
          { label: '行程信息', key: '3' },
          { label: '车次信息', key: '4' },
          { label: '开票信息', key: '5' },
          { label: '交易信息', key: '6' },
          { label: '优惠券套餐', key: '7' },
          { label: '保险信息', key: '8' },
          { label: '操作日志', key: '9' }
        ],
        newRemark: '',
        isShowRemark: false,
        isOpenRemark: true,
        info: {},
        refundData: [],
        healthCodes: [],
        driveHealthCodes: [],
        isRedHandle: false,
        insureForChange: [],
        currentSerialNo: '',
        logLoading: false,
        showLog: false,
        logList: [],
        flightPlanId: '',
        status: '',
        tcLoading: false,
        needBack: false,
        loading: false,
        // editdata: {}
        showItinerary: false,
        changeEndTime: '' // 最晚可改签时间
      }
    },
    computed: {
      isCancelShow() {
        const { orderBaseInfo, tc } = this.info || {}
        const { orderState = '' } = orderBaseInfo || {}
        return tc && orderState !== '已取消' && orderState !== '已改签'
      },
      changeShow() {
        const { modeType, buyChannel, state } = this.info
        let isAfter = false
        let isBefore = false
        let res = false
        if (modeType === 2) {
          isAfter = dayjs(`${this.info.preferredDepartureStart}`).isAfter(
            dayjs().format('YYYY-MM-DD HH:mm:ss')
          )
          isBefore = this.getEndTime(this.info.preferredDepartureStart)
        } else {
          if (this.info.tripInfo) {
            // const departureDateTime='2026-01-14 12:30:00'
            const departureDateTime = this.info.tripInfo.departureDateTime
            isAfter = dayjs(`${departureDateTime}`).isAfter(dayjs().format('YYYY-MM-DD HH:mm:ss'))
            isBefore = this.getEndTime(departureDateTime)
          }
        }
        if (isAfter) {
          // 当前时间出发之前
          if (buyChannel === 2 || state === 0 || state === 7 || state === 8) {
            res = true
          }
        } else {
          const userMerchantId = window.localStorage.getItem('merchantId')
          // 当前时间出发之后
          if (userMerchantId === '0' && (state === 0 || state === 8) && isBefore) {
            res = true
          }
        }

        return res
        // const { modeType } = this.info

        // if (modeType === 2) {
        //   return dayjs(`${this.info.preferredDepartureStart}`).isAfter(
        //     dayjs(this.getEndTime(this.info.preferredDepartureStart)).format('YYYY-MM-DD HH:mm:ss')
        //   )
        // }

        // return (
        //   this.info.tripInfo &&
        //   dayjs(`${this.info.tripInfo.departureDateTime}`).isAfter(
        //     dayjs(this.getEndTime(this.info.tripInfo.departureDateTime)).format(
        //       'YYYY-MM-DD HH:mm:ss'
        //     )
        //   )
        // )
      }
    },
    methods: {
      getEndTime(v) {
        const date = new Date(v)
        const time = date.getTime()
        const now = new Date().getTime()
        const start = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(), // 当天日期
          0,
          0,
          0,
          0 // 精确到当天最后一毫秒
        ).getTime()
        const end = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(), // 当天日期
          23,
          59,
          59,
          999 // 精确到当天最后一毫秒
        ).getTime()
        return time > start && time < end && now > start && now < end
      },

      // 初始化数据
      init(row, needBack) {
        this.needBack = needBack
        // this.editdata = row
        this.flightPlanId = row.id
        this.logList = []
        this.showLog = false
        this.orderId = row.id
        // this.title = `订单详情 【 ${row.orderNo} 】`
        this.visible = true
        this.loading = true
        newDetails(row.id)
          .then((resp) => {
            if (resp.data) {
              resp.data.invoiceInfo = resp.data.invoiceInfo.sort(
                (a, b) => new Date(b.applyTime).getTime() - new Date(a.applyTime).getTime()
              )
              this.info = resp.data || {}
              this.title = this.info.orderNo ? `订单详情 【 ${this.info.orderNo} 】` : '订单详情'
              this.insureForChange = resp.data.insuranceInfo
            }
          })
          .finally(() => {
            // this.$emit('closeLoading')
            this.loading = false
          })
        // 获取订单最早一次时间(包含所有的改签单)
        this.getOrderMaxTime(row.id)
        this.isFerryOrder = false
      },
      // tab锚点
      onScroll(e) {
        const scrollItems = document.querySelectorAll('.scroll-item')
        for (let i = scrollItems.length - 1; i >= 0; i--) {
          // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
          const judge = e.target.scrollTop >= scrollItems[i].offsetTop - scrollItems[0].offsetTop
          if (judge) {
            this.activeStep = i.toString()
            break
          }
        }
      },
      handleSelect(index) {
        const target = document.querySelector('.scroll_cls')
        const scrollItems = document.querySelectorAll('.scroll-item')
        // 判断滚动条是否滚动到底部
        if (target.scrollHeight <= target.scrollTop + target.clientHeight) {
          this.activeStep = index
        }
        const total = scrollItems[index].offsetTop - scrollItems[0].offsetTop // 锚点元素距离其offsetParent(这里是body)顶部的距离(待滚动的距离)
        let distance = document.querySelector('.scroll_cls').scrollTop // 滚动条距离滚动区域顶部的距离
        // let distance = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset // 滚动条距离滚动区域顶部的距离(滚动区域为窗口)
        // 滚动动画实现, 使用setTimeout的递归实现平滑滚动，将距离细分为50小段，10ms滚动一次
        // 计算每一小段的距离
        let step = total / 50
        if (total > distance) {
          smoothDown(document.querySelector('.scroll_cls'))
        } else {
          const newTotal = distance - total
          step = newTotal / 50
          smoothUp(document.querySelector('.scroll_cls'))
        }

        // 参数element为滚动区域
        function smoothDown(element) {
          if (distance < total) {
            distance += step
            element.scrollTop = distance
            setTimeout(smoothDown.bind(this, element), 10)
          } else {
            element.scrollTop = total
          }
        }

        // 参数element为滚动区域
        function smoothUp(element) {
          if (distance > total) {
            distance -= step
            element.scrollTop = distance
            setTimeout(smoothUp.bind(this, element), 10)
          } else {
            element.scrollTop = total
          }
        }

        document.querySelectorAll('.scroll-item').forEach((item, index1) => {
          if (index === index1) {
            item.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            })
          }
        })
      },

      // 获取操作日志
      showLogData() {
        this.showLog = !this.showLog
      },
      // 查看同城接送订单详情
      ferryOrderDetails(row) {
        this.isFerryOrder = true
        const obj = {
          ...row,
          ferryOrderNo: row.orderNo,
          // tc: this.editdata.tc
          tc: this.info.tc
        }
        this.$nextTick(() => {
          this.$refs.orderInfo.init(obj)
        })
      },
      handleRefund() {
        this.refundShowDialog = true
        this.$nextTick(() => {
          this.$refs.refundTicket.init(this.orderId, this.info)
        })
      },
      openBtn() {
        this.isOpenRemark = false
        this.isShowRemark = true
      },
      cancel() {
        this.isOpenRemark = true
        this.isShowRemark = false
      },
      sumitRemark() {
        if (!this.newRemark) {
          this.$message.warning('请输入备注')
          return
        }
        const pms = {
          id: this.info.id,
          mobilePhone: '',
          remarks: this.newRemark
        }
        setMbOrMk(pms).then((resp) => {
          if (resp.code === 0) this.$message.success('修改成功')
          this.refreshData()
          this.isOpenRemark = true
          this.isShowRemark = false
          this.newRemark = ''
        })
      },
      handleClose(done) {
        this.visible = false
        if (this.needBack) {
          this.$router.back()
        }
        this.$nextTick(() => {
          this.activeStep = '0'
          this.info = {}
          this.needBack = false
          done()
        })
      },
      handleRefundDetails() {
        refundDetails(this.info.id).then((resp) => {
          this.refundData = resp.data.tickets
          console.log(resp)
        })
      },

      // 结束行程请求
      endOfTrip(orderId) {
        resetEndOfTrip(orderId).then((res) => {
          const { code, msg } = res
          if (code !== 0) {
            this.$message.error(msg)
          } else {
            this.$message.success('操作成功')
          }
        })
      },
      getRedInfo(serialNo) {
        resetRed(serialNo)
          .then((res) => {
            const { code, data } = res
            this.$loading().close()
            if (code !== 0) {
              // this.$message.error(msg)
              // this.handleRefundDetails()
            } else if (!data) {
              this.$message.error('红冲失败')
              this.refreshData()
            } else {
              this.$message.success('操作成功')
              this.refreshData()
            }
          })
          .finally(() => {
            this.$loading().close()
            this.isRedHandle = false
          })
      },

      handleResetRed(serialNo) {
        this.currentSerialNo = serialNo
        this.$confirm('确定将发票红冲吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            // this.$loading({});
            this.isRedHandle = true
            this.getRedInfo(serialNo)
          })
          .finally(() => {
            this.$loading().close()
          })
      },

      // 刷新
      refreshData() {
        newDetails(this.orderId).then((resp) => {
          this.info = resp.data
        })
      },
      // 结束行程按钮
      handleEndTrip() {
        this.$confirm(
          '为保障司乘双方权益，请确认司机已将乘客送达目的地后再结束该订单',
          '确认要结束行程订单吗？',
          {
            confirmButtonText: '确定',
            cancelButtonText: '稍后看看',
            type: 'warning'
          }
        )
          .then(() => {
            this.endOfTrip(this.orderId)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      async handleChangeTicket() {
        const { orderId } = this.info.customOrderDetailBossChangeInfo
        const { code } = await checkRebook(orderId)
        if (code) return
        this.changeTicketVisible = true
        const params = {
          lineId: this.info.lineId,
          orderBaseInfo: this.info.orderBaseInfo, // 基础信息
          trainsInfo: this.info.trainsInfo, // 车次信息
          pickUpInfo: this.info.pickUpInfo, // 接送信息
          preferredDepartureStart: this.info.preferredDepartureStart,
          preferredDepartureEnd: this.info.preferredDepartureEnd,
          modeType: this.info.modeType,
          ...this.info.customOrderDetailBossChangeInfo
        }
        this.$nextTick(() => {
          this.$refs.changeTicket.init(params)
        })
      },
      // 预览乘客码
      openPreview(index = 0, row) {
        this.healthCodes = []
        this.healthCodes.push({ thumbUrl: row, url: row })
        this.$ImagePreview(this.healthCodes, index, {
          closeOnClickModal: true,
          beforeClose: () => {
            this.$message.success('关闭回调')
          }
        })
      },
      // 预览司机码
      openDriverPreview(index = 0, row) {
        this.driveHealthCodes = []
        this.driveHealthCodes.push({ thumbUrl: row, url: row })
        this.$ImagePreview(this.driveHealthCodes, index, {
          closeOnClickModal: true,
          beforeClose: () => {
            this.$message.success('关闭回调')
          }
        })
      },

      // 取消同程订单
      async handleCancelOrder() {
        this.tcLoading = true
        const { code } = await cancelOrder({
          // orderNo: this.editdata.orderNo
          orderNo: this.info.orderNo
        })
        this.tcLoading = false
        if (code !== 0) {
          return
        }
        this.$message.success('取消成功')
        this.visible = false
        this.$emit('cancelTcOrder')
      },
      async handleItinerary() {
        this.showItinerary = true
        this.$refs.sendItinerary.init(this.orderId)
      },
      colseItinerary() {
        this.showItinerary = false
      },
      async getOrderMaxTime(orderId) {
        // 获取改签时间
        const { code, data } = await orderMaxTime(orderId)
        if (code) return
        this.changeEndTime = data
      }
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('scroll', this.onScroll, true)
      })
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .el-drawer__header {
    padding: 10px 20px 0;
    margin-bottom: 10px;
  }
  ::v-deep .el-step__title {
    font-size: 14px;
  }
  ::v-deep .el-steps--horizontal {
    margin-left: 20px;
    padding: 0 10px;
  }

  ::v-deep .el-step__main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .transactionInfo {
    margin: 0 20px;
    padding-top: 10px;
    font-size: 14px;
  }

  .transactionInfo > span {
    margin-right: 10px;
  }

  .scroll_cls {
    height: 75vh;
    overflow: auto;
  }

  .titleBox {
    margin-left: 2px;
    margin-top: 20px;
    display: flex;
  }

  .title {
    font-weight: 600;
  }

  .carInfo {
    margin: 12px 0;
    padding: 0 10px;
  }

  .jumpMenu {
    margin-left: 10px;
  }

  .topBox {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .tipsBtn {
    padding-right: 15px;
  }

  .tipsBox {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 13px;
    color: #9f9f9f;
  }

  .tipsBox span {
    margin-left: 5px;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 2px;
  }

  .log-table {
    margin-left: 20px;
  }
</style>
